import React, { useCallback } from "react";
import { elementType, func, oneOfType, string } from "prop-types";
import Link from "../Link";
import { classes } from "../utils/classes";
import { useHeader } from "../Header/context";
import { useDropDown } from "../utils/DropDownProvider/context";

const NavbarItemLink = ({ Tag = Link, className, onClick = () => {}, ...props }) => {
	const isLink = Tag === Link;
	const config = isLink && { isBaseClassName: false };
	const { changeCurrentAction, initialAction, currentAction } = useDropDown();
	const { onClose } = useHeader();
	const handleClick = useCallback(
		e => {
			if (isLink) {
				changeCurrentAction(null);
			}
			onClick(e);
			if (isLink) {
				onClose();
				setTimeout(() => {
					changeCurrentAction(initialAction);
				}, 100);
			}
		},
		[changeCurrentAction, initialAction, currentAction, isLink],
	);
	return (
		<Tag
			{...config}
			className={classes("nav__item-link", className)}
			onClick={handleClick}
			{...props}
		/>
	);
};

NavbarItemLink.propTypes = {
	Tag: oneOfType([string, elementType]),
	onClick: func,
	href: string,
	className: string,
};

export default NavbarItemLink;
